import { render, staticRenderFns } from "./TransferSubsidiaries.vue?vue&type=template&id=5cc9de26&scoped=true"
import script from "./TransferSubsidiaries.vue?vue&type=script&lang=js"
export * from "./TransferSubsidiaries.vue?vue&type=script&lang=js"
import style0 from "./TransferSubsidiaries.vue?vue&type=style&index=0&id=5cc9de26&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5cc9de26",
  null
  
)

export default component.exports